import { useEffect, useImperativeHandle, useRef } from "react";
import { useReactFlow } from "@xyflow/react";
const EMPTY_FIT_NODE_IDS = [];
/** Both the imperative handle and the declarative prop frame nodes this way. */ export function fitViewToNodes(reactFlow, nodeIds, options) {
    const padding = options?.padding ?? 0.3;
    const duration = options?.duration ?? 300;
    if (nodeIds.length === 0) {
        reactFlow.fitView({
            padding,
            duration
        });
    } else {
        reactFlow.fitView({
            nodes: nodeIds.map((id)=>({
                    id
                })),
            padding,
            duration
        });
    }
}
/**
 * Lives inside the React Flow provider, which is the only place the viewport
 * can be driven from. Shared by the read-only visualization and the editor.
 */ export function FlowViewportHandler({ flowRef, fitRequest, layoutReady, savedPositions }) {
    const reactFlow = useReactFlow();
    useImperativeHandle(flowRef ?? null, ()=>({
            fitToNodes: (nodeIds, options)=>fitViewToNodes(reactFlow, nodeIds, options)
        }), [
        reactFlow
    ]);
    // The payload is read through a ref so only the request id — and the position
    // source — decide WHEN to fit; a caller rebuilding the same list must not.
    const nodeIdsRef = useRef(EMPTY_FIT_NODE_IDS);
    nodeIdsRef.current = fitRequest?.nodeIds ?? EMPTY_FIT_NODE_IDS;
    // Null until there is something to frame AND a layout to frame it in, so the
    // effect only has to react to it changing.
    const fitTarget = layoutReady && fitRequest ? fitRequest.id : null;
    useEffect(function fitRequestedNodes() {
        if (fitTarget === null) return;
        fitViewToNodes(reactFlow, nodeIdsRef.current);
    }, [
        fitTarget,
        savedPositions,
        reactFlow
    ]);
    return null;
}

//# sourceMappingURL=viewportFit.js.map